import { FilterItem } from "./types";

export const handleStateChange = (setFunction: React.Dispatch<React.SetStateAction<FilterItem[]>>, index: number) => {
  setFunction((prev) =>
    prev.map((s, idx) => {
      s.selected = idx === index;
      return s;
    })
  );
};

export const handleMultiSelectStateChange = (
  setFunction: React.Dispatch<React.SetStateAction<FilterItem[]>>,
  index: number,
  prevSelected: boolean,
  all: boolean
) => {
  setFunction((prev) =>
    prev.map((s, idx) => {
      if (all) {
        // Select "All" and deselect others
        s.selected = idx === index;
      } else {
        // Deselect "All" and multi-select possible
        if (s.value === "all") {
          s.selected = false;
        } else if (idx === index) {
          s.selected = !prevSelected;
        }
      }
      return s;
    })
  );
};
